// extracted by mini-css-extract-plugin
export default {"subHeaderWrapper":"styles_subHeaderWrapper__GEZrk"};